import { yupResolver } from "@hookform/resolvers/yup";
// import RefreshIcon from "@mui/icons-material/Refresh";
import { Button, Grid, Tab, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { lazy, Suspense } from "react";

import {
  EstadosActivacionInstallOTEnumChoice,
  EstadosOrdenTrabajoEnumChoice,
  gridSizeMdLg12,
  ROUTER_PATHS,
  useTabsFormOnly,
} from "@/shared";
import {
  OrdenTrabajoQueryKeysEnum,
  SaveOTTecnicoInstallPendingData,
  useUpdateContrato,
  useUpdateOrdenTrabajo,
} from "@/shared/actions/erp";
import {
  CustomButtunsRejectConfirm,
  CustomTabPanel,
  FormTabsOnly,
  TabsFormBoxScene,
} from "@/shared/components/ui";
import {
  AlertSeverityEnum,
  Contrato,
  OrdenTrabajo,
} from "@/shared/interfaces";
import {
  a11yProps,
  ordenTrabajoSubeTecnicoFormSchema,
  texto,
} from "@/shared/utils";
import { hasPermission } from "@/shared/utils/general/has-permission.utils";
import { PermissionsEnum } from "@/auth/interfaces";
import {
  useEquiposAdicionales,
  useMaterialesUtilizadosStore,
} from "@/store/erp";
import { useUiConfirmModalStore, useUiStore } from "@/store/ui";
import RejectInstalacionAsigTecModal from "../../../tables/RejectInstalacionAsigTecModal";
import dayjs from "dayjs";
import { useAuthStore } from "@/store/auth";
import {
  CustomAlertCard,
  CardPersonalizado,
} from "@/shared/components/ui/Alerts";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
// import { CategoryProducCodeEnum } from "@/shared/interfaces/erp/inventario";
// import { useGeolocation } from "../../../../hooks";
// import { toast } from "react-toastify";

import { useGetProspectoByIdProspecto } from "@/shared/actions/erp";
// import { validarOrdenTrabajo } from "../utils/validarOrdenTrabajo";
// import { calcularHistorialCambiosCoordenadas, construirPayloadOrdenTrabajo } from "../utils/construirPayloadOrdenTrabajo";
import { useOptionsONT } from "../hooks/useOptionsONT";
import { useIniciarInstalacion } from "../hooks/useIniciarInstalacion";
import { useSaveOrdenTrabajo } from "../hooks/useSaveOrdenTrabajo";
import { useResetFormWithOTData } from "../utils/useResetFormWithOTData";
import { toast } from "react-toastify";
export interface SaveOrdenTrabajoAsignadaTecProps {
  title: string;
  ordentrabajo: OrdenTrabajo;
  isCorrentingData?: boolean;
}



const OTDetalleClienteInstallTecnicoFormTab = lazy(
  () => import("../../OTDetalleClienteInstallTecnicoFormTab")
);

const OTInstalacionTecnicoFormTab = lazy(
  () => import("../../OTInstalacionTecnicoFormTab")
);

const OTMaterialesInstallTecnicoFormTab = lazy(
  () => import("../../OTMaterialesInstallTecnicoFormTab")
);

const OTDetalleInstallTecnicoFormTab = lazy(
  () => import("../../OTDetalleInstallTecnicoFormTab")
);





const SaveOrdenTrabajoAsignadaTec: React.FC<
  SaveOrdenTrabajoAsignadaTecProps
> = ({ title, ordentrabajo, isCorrentingData = false }) => {
  const navigate = useNavigate();
  const returnUrlInstalacionesTecnicoPage = ROUTER_PATHS.tecnico.ordenenTrabajoNav;
  const queryClient = useQueryClient();
  const currentUser = useAuthStore((s) => s.user);
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore((s) => s.setConfirmDialogIsOpen);
  const id_pros = ordentrabajo.prospecto_data?.id_prospecto;
  // El prospecto solo aporta el aviso de "representante de persona con
  // discapacidad". El endpoint exige api.view_prospecto, que el grupo TECNICO
  // INSTALACIONES no tiene: sin este guard el técnico recibe el toast de 403 al
  // abrir la orden. Con permiso se consulta igual que antes.
  const puedeVerProspecto = hasPermission(PermissionsEnum.api_view_prospecto);

  ///* hooks -----------------------
  const { handleMethodChange, valueTab } = useTabsFormOnly({ initialTabValue: 1 });
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const { data: dataProspecto } = useGetProspectoByIdProspecto(
    puedeVerProspecto ? id_pros : undefined,
  );
  const mensaje = [
      ordentrabajo.preventa_data.requiere_contrato_fisico ? "FISICO" : "DIGITAL",
      dataProspecto?.es_curador_tutor
        ? "Es representante de persona con discapacidad: SI"
        : null,
    ]
      .filter(Boolean)
      .join("\n");
      

  // ================== EQUIPOS ==================
  const clearAllMaterials = useMaterialesUtilizadosStore(
    (s) => s.clearAllMaterials,
  );
  const {
    productos: MATERIALES_UTILIZADOS,
    handleAgregarSeriesArrayProductos,
    setProductos: setMaterialesUtilizados,
  } = useCargarSeriesProductos();
  const productos_adicionales = useEquiposAdicionales((s) => s.productos);
  const setProductosAdicionales = useEquiposAdicionales((s) => s.setProductos);
  // ================== EQUIPOS --- END ==================
  ///* form -----------------------
  const form = useForm<any>({
    resolver: yupResolver(ordenTrabajoSubeTecnicoFormSchema) as any,
    defaultValues: {
      es_borrador: false,
      estado: true,
      es_conexion_tierra: false,
      es_regulador: false,
      ont_a_utilizar: ordentrabajo?.equipos_utilizados?.[0] || "",
      observacion_incidencia: ordentrabajo?.observaciones?.observacion_incidencia,
      url_foto_identificacion_delantera:
        ordentrabajo?.preventa_data?.url_foto_identificacion_delantera || null,
      fecha_hora_inicio_instalacion:
        ordentrabajo?.fecha_hora_inicio_instalacion || "",
      ssid: ordentrabajo?.contrato_data?.ssid || "",
      password_wifi: ordentrabajo?.contrato_data?.password_wifi || "",
    },
  });

  const {
    handleSubmit,
    formState: { errors, isValid },
  } = form;

  const observacionActualizacionTecnico = useWatch({
    control: form.control,
    name: "observaciones.observacion_actualizacion_tecnico",
  });
  const estadoOrdenTrabajo = useWatch({
    control: form.control,
    name: "estado_orden_trabajo",
  });
  const motivoRechazoNombre = useWatch({
    control: form.control,
    name: "motivo_rechazo_data.nombre",
  });
  const fechaSolicitadaActualizacionTecnico = useWatch({
    control: form.control,
    name: "observaciones.fecha_solicitada_actualizacion_tecnico",
  });
  useResetFormWithOTData({
    form,
    ordentrabajo,
    setMaterialesUtilizados,
    setProductosAdicionales,
  });


  ///* mutations -----------------------

  const updateOrdenTrabajoMutation =
    useUpdateOrdenTrabajo<SaveOTTecnicoInstallPendingData>({
      navigate,
      returnUrl: returnUrlInstalacionesTecnicoPage,
      customMessage: "Orden de trabajo subida correctamente",
      customSuccessCallback: () => {
        clearAllMaterials();
      },
    });
  const updateContratoMutation = useUpdateContrato<Pick<Contrato, 'ssid' | 'password_wifi'>>({
    enableSuccessAlert:false,
    customSuccessCallback: () => {
      toast.success('SSID y contraseña actualizados correctamente');
    }
  });

  const updateOrdenTrabajoAdapter = useMemo(
    () => ({
      mutate: ({ id, data }: { id: string | number; data: any }) =>
        updateOrdenTrabajoMutation.mutate({ id: id.toString(), data }),
    }),
    [updateOrdenTrabajoMutation.mutate],
  );

  const updateContratoMutationAdapter = useMemo(
    () => ({
      mutate: ({ id, data }: { id: string | number; data: any }) =>
        updateContratoMutation.mutate({ id: id.toString(), data }),
    }),
    [updateContratoMutation.mutate],
  );

  const { optionsONT, isloadingUbProducto } = useOptionsONT({ ordentrabajo, valueTab, form });

  ///* handlers ============================================
  const refreshData = useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [
        OrdenTrabajoQueryKeysEnum.OrdenTrabajo,
        ordentrabajo?.id_orden_trabajo?.toString() || "",
      ],
    });
  }, [queryClient, ordentrabajo?.id_orden_trabajo]);

  const { onSave } = useSaveOrdenTrabajo({
    form,
    ordentrabajo,
    isValid,
    isCorrentingData,
    currentUser,
    handleAgregarSeriesArrayProductos,
    MATERIALES_UTILIZADOS,
    productos_adicionales,
    updateOrdenTrabajoMutation: updateOrdenTrabajoAdapter,
    updateContratoMutation: updateContratoMutationAdapter,
    clearAllMaterials,
    refreshData
  })

  const onSubmitError = useCallback((err:any)=>{
    if (
      ordentrabajo?.estado_activacion !==
      EstadosActivacionInstallOTEnumChoice.GESTIONADA
    ) {
      toast.error("La orden de trabajo aún no ha sido gestionada por ACTIVACIONES");
    }

    return toast.error(`Faltan campos por llenar: ${Object.keys(err).join(", ")?.replaceAll("_", " ")?.toUpperCase()}`);

  },[
    ordentrabajo,
  ]);

  const onSaveFinal = useCallback(
    (data: any) => onSave({ ...data, es_borrador: false }),
    [onSave],
  );


  const submitHandler = useMemo(
    ()=>handleSubmit(onSaveFinal,onSubmitError),
    [
      handleSubmit,
      onSaveFinal,
      onSubmitError
    ]
  );

  const customButtons = useMemo(() => (
      <CustomButtunsRejectConfirm
          confirmTextBtn={isCorrentingData ? "Actualizar" : "Guardar y Finalizar"}
          showRejectBtn={!isCorrentingData}
          rejectTextBtn={"Reportar Novedad"}
          auxNextToCancel={false}
          onCancel={() => {
            setConfirmDialog({
              isOpen: true,
              title: "Abandonar Formulario",
              subtitle:
                "¿Está seguro de abandonar el formulario? Se perderán todos los cambios realizados.",
              onConfirm: () => {
                setConfirmDialogIsOpen(false);
                clearAllMaterials();
                navigate(returnUrlInstalacionesTecnicoPage);
              },
              confirmTextBtn: "SI",
              cancelTextBtn: "NO",
            });
          }}
          //  ----------- CONFIRMAR -----------
          onConfirm={submitHandler}
          //  ----------- RECHAZAR -----------
          onReject={() => {
            // Prerechazo
            setOpenRejectModal(true);
          }}
          // auxiliar btn (refresh) ----------------
          showAuxiliarBtn={!isCorrentingData}
          auxiliarBtn={
            <Grid item>
              <Button variant="outlined" color="primary"
                onClick={async () => {
                  await onSave({ ...form.getValues(), es_borrador: true });
                }}
              >
                Guardar Borrador
              </Button>
            </Grid>
          }
        />
    ),[
      isCorrentingData,
      submitHandler,
      navigate,
      onSave,
      form,
      setConfirmDialog,
      setConfirmDialogIsOpen,
      clearAllMaterials,
      returnUrlInstalacionesTecnicoPage,
    ]
  );



  const {
    hasFechaHoraInicioInstalacion,
    fechaHoraInicioInstalacion,
    coords,
    permissionStatus,
    error,
    iniciarInstalacion,
  } = useIniciarInstalacion({ ordentrabajo, currentUser, refreshData });


  
  ///* effects -----------------------
  useEffect(() => {
    setMaterialesUtilizados([]);
    setProductosAdicionales([]);
    setProductosAdicionales(ordentrabajo?.materiales_equipos_adicionales || []);
  }, []);


  if (!id_pros) return;
  return (
    <TabsFormBoxScene
      titlePage={title}
      showBtns={false}
      // // custom btns ---------
      showCustomBtns={true}
      customBtns={customButtons}
      // // tabs ---------
      tabs={
        <>
          {observacionActualizacionTecnico &&
            estadoOrdenTrabajo ===
            EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR ? (
            <Grid container spacing={2} justifyContent={"center"} my={2}>
              <CustomAlertCard
                alertTitle="Actualización solicitada por Auditoría"
                alertMessage={`${texto.correccion_solicitada_tecnico_auditoria} \n ${motivoRechazoNombre}: ${observacionActualizacionTecnico} (${dayjs(fechaSolicitadaActualizacionTecnico).format("DD/MM/YYYY HH:mm:ss") || "Fecha no definida"})`}
                bgColorAlert="RED"
                alertColor="error"
              />
            </Grid>
          ) : null}
          <Grid container spacing={2} justifyContent={"center"} my={1}>
            {hasFechaHoraInicioInstalacion ? (
              <>
                <Typography variant="body1" color="success">
                  {`
                Instalación iniciada a las 
                ${dayjs(fechaHoraInicioInstalacion).format("HH:mm:ss")} 
                del día ${dayjs(fechaHoraInicioInstalacion).format("DD/MM/YYYY")}
                `}
                </Typography>
                <br />
                <Grid
                  {...gridSizeMdLg12}
                  sx={{ marginTop: 2 }}
                  container
                  justifyContent={"center"}
                >
                  <CardPersonalizado
                    alertTitle="Tipo de contrato"
                    alertMessage={
                      mensaje
                    }
                    bgColorAlert="GRAY"
                    alertColor="error"
                  />
                </Grid>
              </>
            ) : (
              <Grid container {...gridSizeMdLg12} gap={1}>
                {(permissionStatus === "denied" ||
                  permissionStatus === "prompt") && (
                    <Grid {...gridSizeMdLg12} container justifyContent={"center"}>
                      <CustomAlertCard
                        alertTitle="Habilite el acceso a la ubicación"
                        alertMessage={
                          error ??
                          "Necesitamos acceso a tu ubicación para continuar. Actívala en tu navegador y vuelve a intentarlo."
                        }
                        bgColorAlert="RED"
                        alertColor="error"
                      />
                    </Grid>
                  )}
                {permissionStatus === "loading" && (
                  <Grid {...gridSizeMdLg12} container justifyContent={"center"}>
                    <CustomAlertCard
                      alertTitle="Habilite el acceso a la ubicación"
                      alertMessage={
                        coords?.accuracy
                          ? `Precisión actual: ${Math.round(coords.accuracy)}m — esperando señal GPS...`
                          : "Iniciando GPS, mantente en campo abierto para mejor señal."
                      }
                      alertColor="info"
                    />
                  </Grid>
                )}

                <Grid {...gridSizeMdLg12} container justifyContent={"center"}>
                  <CardPersonalizado
                    alertTitle="Tipo de contrato"
                    alertMessage={
                      mensaje
                    }
                    bgColorAlert="GRAY"
                    alertColor="error"
                  />
                </Grid>
                <Grid {...gridSizeMdLg12} container justifyContent={"center"}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="info"
                    onClick={async () => await iniciarInstalacion()}
                  >
                    Iniciar Instalación
                  </Button>
                </Grid>
              </Grid>
            )}
          </Grid>
          <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
            <Tab label="ORDEN TRABAJO" value={1} {...a11yProps(1)} />
            <Tab label="DETALLE INSTALACIÓN" value={2} {...a11yProps(2)} />
            <Tab label="INFORMACIÓN CLIENTE" value={3} {...a11yProps(3)} />
            <Tab label="MATERIALES" value={4} {...a11yProps(4)} />
          </FormTabsOnly>
        </>
      }
    >
      {/* //* tabs content */}
      <Suspense
        fallback={
          <Typography textAlign="center">
            Cargando sección...
          </Typography>
        }
      >
        {/* ===================== ORDEN TRABAJO ===================== */}
        <CustomTabPanel index={valueTab} value={1}>
          {valueTab === 1 && (
            <OTInstalacionTecnicoFormTab
              form={form}
              errors={errors}
              shrink={true}
            />
          )}
        </CustomTabPanel>

        {/* ===================== DETALLES DE INSTALACIÓN ===================== */}
        <CustomTabPanel index={valueTab} value={2}>
          {valueTab === 2 && (
            <OTDetalleInstallTecnicoFormTab
              form={form}
              errors={errors}
              shrink={true}
              coords={ordentrabajo?.agendamiento_data?.coordenadas || ""}
              ordenTrabajo={ordentrabajo!}
              isOnlyView={true}
              canDragMarker
              canRuler
            />
          )}
        </CustomTabPanel>

        {/* ===================== DETALLES CLIENTE ===================== */}
        <CustomTabPanel index={valueTab} value={3}>
          {valueTab === 3 && (
            <OTDetalleClienteInstallTecnicoFormTab
              form={form}
              errors={errors}
              shrink={true}
            />
          )}
        </CustomTabPanel>

        {/* ===================== MATERIALES ===================== */}
        <CustomTabPanel index={valueTab} value={4}>
          {valueTab === 4 && (
            <OTMaterialesInstallTecnicoFormTab
              form={form}
              ordenTrabajo={ordentrabajo!}
              optionsONT={optionsONT}
              isloadingUbProducto={isloadingUbProducto}
            />
          )}
        </CustomTabPanel>
      </Suspense>

      {/* =================== DIALOGS =================== */}
      <RejectInstalacionAsigTecModal
        open={openRejectModal}
        setOpen={setOpenRejectModal}
        idOrdenTrabajo={ordentrabajo?.id_orden_trabajo!}
        observacionesOrdenTrabajo={ordentrabajo?.observaciones}
        ordentrabajo={ordentrabajo}
      />

    </TabsFormBoxScene>
  );
};

export default SaveOrdenTrabajoAsignadaTec;
